import platformUtils from '../privates/platformUtils';
import monitoring from '../privates/monitoring';

platformUtils.setExperiments(self.openExperiments);
platformUtils.initMonitoringServices(self.monitoringServices);
platformUtils.setMonitoringFactories(self.monitoringFactories);
monitoring.initRaven();
